import type {RepositoryDataResponse} from '@github-ui/data-router-error-helpers'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {InternalIssueNewPageUrlArgumentsMetadataQuery} from '@github-ui/server-persisted-queries'
import type {InternalIssueNewPageUrlArgumentsMetadataQueryQuery} from '@github-ui/server-persisted-queries/types/InternalIssueNewPageUrlArgumentsMetadataQuery'

import {issuesAppBuilder} from '../config/app-builder'

// RepositoryDataResponse exposes the errors array so handleRepositoryDataError can detect FORBIDDEN/SAML.
export type IssueNewPayload = RepositoryDataResponse<InternalIssueNewPageUrlArgumentsMetadataQueryQuery> & {
  semantic_similarity_duplicate_issue_detection?: boolean
}

// The URL params that prefill the new-issue form; the BFF (issues#new) derives the
// `withAssignees`/`assigneeLogins`/... GraphQL variables from them, mirroring the
// frontend variable-transformers.
const URL_ARGUMENT_PARAMS = [
  'assignees',
  'labels',
  'milestone',
  'projects',
  'type',
  'template',
  'created_from_discussion_number',
] as const

export function buildIssueNewRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('issueNewRoute', {
    path: '/:owner/:repo/issues/new',
    queries: [
      mainQuery<IssueNewPayload>({
        // owner/name are resolved from the pathname by the BFF; forward the persisted-query id
        // plus the prefill params so the BFF can map them to query variables.
        queryDeps: ({pathname, searchParams}) => ({
          pathname,
          searchParams: {
            queryId: InternalIssueNewPageUrlArgumentsMetadataQuery,
            ...Object.fromEntries(
              URL_ARGUMENT_PARAMS.flatMap(param => {
                const value = searchParams.get(param)
                return value ? [[param, value]] : []
              }),
            ),
          },
        }),
      }),
    ],
  })
}

export const issueNewRoute = buildIssueNewRoute(issuesAppBuilder)
